import { render, staticRenderFns } from "./LeadMatchesModal.vue?vue&type=template&id=e67fe4be&scoped=true&"
import script from "./LeadMatchesModal.vue?vue&type=script&lang=js&"
export * from "./LeadMatchesModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadMatchesModal.vue?vue&type=style&index=0&id=e67fe4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67fe4be",
  null
  
)

export default component.exports